function custom() {
    $(".product_picker__contents").slick({
        dots: !1,
        arrows: !1,
        infinite: !1,
        swipeToSlide: !0,
        speed: 800,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: !0,
        centerMode: !0,
        centerPadding: "40px",
        responsive: [{ breakpoint: 768, settings: "unslick" }],
    }),
        $(document).ready(function () {
            $(".Collapsible__Inner, .Collapsible__Footer__Inner").hide(),
                $(".Collapsible__Button, .Collapsible__Footer__Button").click(function () {
                    let e = $(this).next(".Collapsible__Inner, .Collapsible__Footer__Inner");
                    $(".Collapsible__Inner, .Collapsible__Footer__Inner").not(e).slideUp(), e.slideToggle(), $(".Collapsible__Button, .Collapsible__Footer__Button").not(this).removeClass("active"), $(this).toggleClass("active");
                });
        }),
        $(".group_item button").click(function () {
            $(this).parent().siblings().removeClass("active"), $(this).parent().siblings().children().removeClass("active");
        }),
        $(".open-filter").click(function () {
            $(".filter-wrap").slideToggle("slow"), $("body").addClass("active"), $("aside.facets-wrapper").addClass("active");
        }),
        $(".exit-filter").click(function () {
            $(".filter-wrap").slideToggle("slow"), $("body").removeClass("active"), $("aside.facets-wrapper").removeClass("active");
        }),
        $(".filter-wrap").on("click", function (e) {
            !1 === $(e.target).is(".filters, .filter-contents, .group-wrap, .group-wrap button, .group-wrap li, .group-wrap span, .group-wrap ul") &&
                ($(".filter-wrap").removeClass("active"), $("body").removeClass("active"), $("aside.facets-wrapper").removeClass("active"));
        }),
        $(".apply-filter").click(function () {
            $(".filter-wrap").slideToggle("slow"), $("body").removeClass("active"), $(".group_item.active").length;
            var e = $(".product-grid .grid__item.active").length;
            $(".Collection__filterCount").html(e + " Items");
        }),
        $(document).ready(function () {
            var e = $(".ColorSwatch.is-active").length;
            $(".filter_numbers_value").html(e),
                $(".filter_number").html("(" + e + ")"),
                $(".filter_numbers").html(e),
                0 == e && ($(".filter__reset_value").addClass("none"), $(".filter_number").addClass("none"), $(".filter__reset").addClass("none"));
        }),
        $(".EmptyState__Action").click(function () {
            $(".product-grid .grid__item").removeClass("active"),
                $(".product-grid .grid__item").removeClass("none"),
                $(this).parent().removeClass("active"),
                $(".group_item button").removeClass("active"),
                $(".group_item").removeClass("active"),
                $(".filter_number").html(""),
                $(".filter_numbers").html(""),
                $(".pagination-wrapper").removeClass("remove"),
                $(".CollectionCount").removeClass("remove"),
                $(".filter_numbers").removeClass("active"),
                $(".Collection__filterCount").removeClass("active");
        }),
        $(document).ready(function () {
            $(".ColorSwatch").on("click", function () {
                var e = $(this).data("checkbox-class"),
                    t = $("." + e);
                t.prop("checked", !t.prop("checked")), t.toggleClass("highlighted-checkbox", t.prop("checked")), $(this).toggleClass("actives", t.prop("checked"));
            });
        }),
        $(document).ready(function () {
            $(".filter_ID").each(function () {
                var e = $(this).attr("class").split(" ")[1];
                $(this).attr("id");
                var t = $("#ColorSwatch-" + e);
                $(this).prop("checked") && (t.addClass("ColorSwatch"), t.addClass("actives"));
            });
        });
    var e = 0;
    $(window).scroll(function () {
        var t = $(this).scrollTop();
        t > e ? $("aside.facets-wrapper").removeClass("scrollUp") : $("aside.facets-wrapper").addClass("scrollUp"), (e = t);
    }),
        $(document).ready(function () {
            $(".tab-content:first").addClass("active-tab"),
                $(".tab-buttons:first").addClass("active-buttons"),
                $(".tab-buttons").click(function () {
                    $(".tab-content").removeClass("active-tab"), $(".tab-buttons").removeClass("active-buttons"), $("#" + $(this).data("tab")).addClass("active-tab"), $(this).addClass("active-buttons");
                });
        }),
        $(document).ready(function () {
            $(".ProductItem__Info").hover(
                function () {
                    $(this).closest(".ProductItem ").find(".Product__colorSelection__wrapper").addClass("visible");
                },
                function () {
                    $(this).closest(".ProductItem ").find(".Product__colorSelection__wrapper").removeClass("visible");
                }
            );
        }),
        $(".Product__colorSelection").each(function () {
            $(this).slick({ dots: !1, arrows: !0, infinite: !1, speed: 300, slidesToShow: 3, slidesToScroll: 1 });
        }),
        $(".Product__colorSelection__wrapper").fadeIn(1e3),
        $(document).ready(function () {
            $(".Product__colorSelection__Lists").each(function () {
                var e = $(this),
                    t = $('<div class="slider_count"></div>').insertAfter(e);
                function i() {
                    var i = e.slick("slickCurrentSlide"),
                        o = e.slick("slickGetOption", "slidesToShow"),
                        s = e.slick("getSlick").slideCount - (i + o);
                    s > 0 ? t.text("+" + s).show() : t.hide();
                }
                e.slick({ dots: !1, arrows: !1, infinite: !1, speed: 300, slidesToShow: 3, slidesToScroll: 3 }),
                    e.on("afterChange", function (e, t, o) {
                        i();
                    }),
                    i();
            });
        });
    let t = $("*[data-scroll-animate]"),
        i = $("*[data-scroll-animate-direction]");
    $(t).each(function () {
        let e = $(this).attr("data-scroll-animate");
        $(this).css("transition-delay", e + "ms");
    }),
        $(i).each(function () {
            let e = $(this).attr("data-scroll-animate-direction");
            $(this).addClass("animate_to_" + e);
        }),
        $(t).each(function () {
            $(window).scrollTop() >= $(this).offset().top - window.innerHeight + 50 && $(this).addClass("animate");
        }),
        $(window).on("scroll", function () {
            $(t).each(function () {
                $(window).scrollTop() >= $(this).offset().top - window.innerHeight + 50 && $(this).addClass("animate");
            });
        });
}
function TabList() {
    $(document).on("click", ".TabList .TabList__Item", function () {
        var e = $(this),
            t = e.parents(".TabList"),
            i = e.closest(".TabList__Item").index();
        t.children().eq(i).addClass("is-active").siblings().removeClass("is-active"),
            t.next().children().eq(i).addClass("is-active").siblings().removeClass("is-active"),
            $(".ProductListWrapper .product-grid, .Featured__CollectionSlider, .Featured__CollectionSlider2").slick("setPosition");
    });
}
function Slider() {
    document.addEventListener("DOMContentLoaded", function () {
        setTimeout(function () {
            if (typeof $.fn.slick === "undefined") {
                console.error("Slick.js not loaded");
                return;
            }
            
            if ($(".Featured__CollectionSlider").length) {
                $(".Featured__CollectionSlider").fadeIn(100).each(function () {
                    $(this).slick({
                        dots: !1,
                        arrows: !0,
                        infinite: !0,
                        centerMode: !1,
                        focusOnSelect: !0,
                        swipeToSlide: !0,
                        nextArrow: ".next",
                        prevArrow: ".prev",
                        speed: 800,
                        lazyLoad: "ondemand",
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        responsive: [
                            { breakpoint: 1007, settings: { slidesToShow: 3, slidesToScroll: 3, dots: !1, infinite: !0, arrows: !0, centerMode: !1 } },
                            { breakpoint: 750, settings: { slidesToShow: 1, slidesToScroll: 1, dots: !1, arrows: !1, infinite: !1, centerMode: !0 } },
                        ],
                    });
                });
            }
            
            if ($(".Featured__CollectionSlider2").length) {
                $(".Featured__CollectionSlider2").fadeIn(100).each(function () {
                    $(this).slick({
                        dots: !1,
                        arrows: !0,
                        infinite: !0,
                        centerMode: !1,
                        focusOnSelect: !0,
                        swipeToSlide: !0,
                        nextArrow: ".next",
                        prevArrow: ".prev",
                        speed: 800,
                        lazyLoad: "ondemand",
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        responsive: [
                            { breakpoint: 1007, settings: { slidesToShow: 3, slidesToScroll: 3, dots: !1, infinite: !0, arrows: !0, centerMode: !1 } },
                            { breakpoint: 750, settings: { slidesToShow: 1, slidesToScroll: 1, dots: !1, arrows: !1, infinite: !1, centerMode: !0 } },
                        ],
                    });
                });
            }
        }, 100);
    }),
        $(".ShopTheLook").each(function () {
            $(this).slick({ dots: !1, arrows: !0, infinite: !0, centerMode: !1, focusOnSelect: !0, swipeToSlide: !0, nextArrow: ".nexts", prevArrow: ".prevs", speed: 800, lazyLoad: "ondemand", slidesToShow: 1, slidesToScroll: 1 });
        }),
        $(".slider-image-content").slick({
            dots: !1,
            arrows: !1,
            infinite: !0,
            centerMode: !0,
            centerPadding: "100px",
            focusOnSelect: !0,
            autoplay: !0,
            autoplaySpeed: 2e3,
            swipeToSlide: !0,
            speed: 2e3,
            lazyLoad: "ondemand",
            slidesToShow: 4,
            slidesToScroll: 4,
            responsive: [
                { breakpoint: 1008, settings: { slidesToShow: 2, slidesToScroll: 2, centerPadding: "50px" } },
                { breakpoint: 769, settings: { slidesToShow: 1, slidesToScroll: 1, centerPadding: "50px" } },
            ],
        }),
        $(".slider-image-as_seen").slick({
            dots: !1,
            arrows: !0,
            infinite: !0,
            centerMode: !0,
            centerPadding: "100px",
            focusOnSelect: !0,
            swipeToSlide: !0,
            speed: 200,
            lazyLoad: "ondemand",
            slidesToShow: 3,
            slidesToScroll: 3,
            nextArrow: ".featnexts",
            prevArrow: ".featprevs",
            responsive: [
                { breakpoint: 1008, settings: { slidesToShow: 2, slidesToScroll: 2, centerPadding: "50px" } },
                { breakpoint: 769, settings: { slidesToShow: 1, slidesToScroll: 1, centerPadding: "50px" } },
            ],
        }),
        document.addEventListener("DOMContentLoaded", function () {
            setTimeout(function () {
                $(".Icon__SlideShowList").fadeIn(100),
                    $(".Icon__SlideShowList").each(function () {
                        $(this).slick({
                            dots: !1,
                            arrows: !1,
                            infinite: !0,
                            speed: 800,
                            slidesToShow: 5,
                            cssEase: "cubic-bezier(0.7, 0, 0.3, 1)",
                            nextArrow: ".icon_next",
                            prevArrow: ".icon_prev",
                            responsive: [{ breakpoint: 749, settings: { arrows: !0, slidesToShow: 2, slidesToScroll: 1, autoplay: !0, autoplaySpeed: 2e3, swipeToSlide: !0, lazyLoad: "ondemand" } }],
                        });
                    });
            }, 100);
        });
}
function accordion() {
    $(".accordion_head").click(function () {
        $(".accordion_body").is(":visible") && ($(".accordion_body").slideUp(300), $(".accordion_body_icon, .accordion_icon_wrapper").removeClass("active")),
            $(this).next(".accordion_body").is(":visible")
                ? ($(this).next(".accordion_body").slideUp(300), $(this).children(".accordion_body_icon, .accordion_icon_wrapper").removeClass("active"))
                : ($(this).next(".accordion_body").slideDown(300), $(this).children(".accordion_body_icon, .accordion_icon_wrapper").addClass("active"));
    }),
        $(".accordion_contents__content").each(function () {
            let e = $(this).children(".accordion_text_content_wrap").children(".accordion_text_content").height() + 15;
            $(this)
                .children(".accodion_title")
                .click(function () {
                    $(this).parent().siblings().children(".accordion_text_content_wrap").animate({ height: "0px" }, 300),
                        $(this).parent().siblings().children(".accodion_title").children().removeClass("active"),
                        $(this).siblings().height() != e
                            ? ($(this)
                                  .siblings()
                                  .animate({ height: e + "px" }, 300),
                              $(this).children().addClass("active"))
                            : ($(this).siblings().animate({ height: "0px" }, 300), $(this).children().removeClass("active"));
                });
        });
}
function LoadTheme__modules() {
    $(".Prescription_Popup .Drawer__Close").on("click", function () {
        var e = $(".Prescription_Popup"),
            t = $(".PageOverlay");
        "false" == e.attr("aria-hidden") && (t.removeClass("is-visible"), e.attr("aria-hidden", "true"));
    }),
        $(".SubscriptionStep3").on("click", function () {
            console.log("heu");
            var e = $(".Prescription_Popup"),
                t = $(".PageOverlay");
            "false" == e.attr("aria-hidden") && (t.removeClass("is-visible"), e.attr("aria-hidden", "true")), $(".Step3").fadeIn();
        }),
        $(".ProductForm--ajax").on("submit", function (e) {
            var t = $(this),
                i = t.find(".ProductForm__AddToCart"),
                o = i.first("span").text();
            i.first("span").text("Adding..."),
                jQuery.post(
                    "/cart/add.js",
                    t.serialize(),
                    function (e) {
                        i.first("span").text("Product added!"), document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: !0 }));
                        var t = $(".Prescription_Popup"),
                            s = $(".PageOverlay");
                        "false" == t.attr("aria-hidden") && (s.removeClass("is-visible"), t.attr("aria-hidden", "true")),
                            setTimeout(() => {
                                i.first("span").text(o),
                                    $(".Head--cart")
                                        .click(function () {
                                            this.click();
                                        })
                                        .click();
                            }, 1e3);
                    },
                    "json"
                ),
                e.preventDefault();
        }),
        $(".SubscriptionForm").on("submit", function (e) {
            var t = $(this),
                i = t.find(".ProductForm__AddToCart"),
                o = i.first("span").text();
            i.first("span").text("Adding..."),
                jQuery.post(
                    "/cart/add.js",
                    t.serialize(),
                    function (e) {
                        var t, s;
                        (t = function () {
                            i.first("span").text("Product added!"), document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: !0 }));
                            var e = $(".Prescription_Popup"),
                                t = $(".PageOverlay");
                            "false" == e.attr("aria-hidden") && (t.removeClass("is-visible"), e.attr("aria-hidden", "true")),
                                setTimeout(() => {
                                    i.first("span").text(o),
                                        $(".Head--cart")
                                            .click(function (e) {
                                                this.click(), e.preventDefault();
                                            })
                                            .click();
                                }, 500);
                        }),
                            (s = $("#product-main-variant")),
                            console.log(s.val()),
                            $.ajax({
                                type: "POST",
                                url: "/cart/add.js",
                                dataType: "json",
                                data: { id: 37616853483719, quantity: 1 },
                                success: function (e) {
                                    $.ajax({
                                        type: "POST",
                                        url: "/cart/add.js",
                                        dataType: "json",
                                        data: { id: s.val(), quantity: 1 },
                                        success: function () {
                                            t();
                                        },
                                    });
                                },
                                error: function (e) {
                                    console.log("error ", e);
                                },
                            });
                    },
                    "json"
                ),
                e.preventDefault();
        });
}
!(function (e) {
    TabList(), Slider(), accordion(), custom(), LoadTheme__modules();
    let t = document.getElementById("main-header");
    window.addEventListener("scroll", function e() {
        window.scrollY > 0 ? t.classList.add("scrolled") : t.classList.remove("scrolled");
    }),
        t.addEventListener("mouseover", function e() {
            t.classList.add("hovered");
        }),
        t.addEventListener("mouseout", function e() {
            t.classList.remove("hovered");
        });
})(jQuery);
